import {
  AddressBadge,
  RequestRandomForm,
  Section,
} from '@/components/molecules'
import { useGenerateRandomWords, useGetRandom, useRequestLastId } from '@/hooks'

import { Box, HStack, Spinner, Stack, Text, VStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useWatchBlocks } from 'wagmi'

const avgWaitingBlock = 1

export const TestConsumer = ({ consumerAddress, subId }) => {
  const [isFetchedAfterMountFirstTime, setIsFetchedAfterMountFirstTime] =
    useState(false)
  const {
    register: registerRequestRandom,
    handleSubmit: handleSubmitRequestRandom,
    watch,
    formState: { errors },
  } = useForm()
  const randomWordsCount = watch('randomWordsCount')
  const confirmationsAmount = watch('confirmationsAmount')

  const [waitingFromBlock, setWaitingFromBlock] = useState()
  useWatchBlocks({
    enabled: waitingFromBlock > 0,
    onBlock: (block) => {
      if (
        waitingFromBlock > 0 &&
        Number(block.number) - Number(waitingFromBlock) >
          Number(avgWaitingBlock) + Number(confirmationsAmount)
      ) {
        setWaitingFromBlock(0)
        refetchLastRequestId()
      }
    },
  })

  const {
    submit: submitGenerateRandom,
    isSuccess,
    result,
    isFetching,
  } = useGenerateRandomWords()

  useEffect(() => {
    if (isSuccess && result && !isFetchedAfterMountFirstTime) {
      setWaitingFromBlock(result.blockNumber)
      setIsFetchedAfterMountFirstTime(true)
    }
  }, [isSuccess, result, waitingFromBlock, isFetchedAfterMountFirstTime])

  useEffect(() => {
    if (isFetching) {
      setIsFetchedAfterMountFirstTime(false)
    }
  }, [isFetching, setIsFetchedAfterMountFirstTime])

  const { data: requestId, refetch: refetchLastRequestId } = useRequestLastId({
    consumerAddress,
  })
  const { data: wordsAmount, isLoading: isLoadingWords } = useGetRandom({
    consumerAddress,
    requestId,
  })

  const requestRandomNumber = () => {
    submitGenerateRandom({
      subId,
      mockConsumerContract: consumerAddress,
      randomWordsCount,
      confirmationsAmount,
    })
  }

  return (
    <Section
      title={'Test Consumer'}
      action={{
        text: 'Request Random Number',
        action: handleSubmitRequestRandom(requestRandomNumber),
        isLoading: waitingFromBlock > 0,
        loadingText: 'Waiting for request fulfillment...',
      }}
      alignItems={'stretch'}
    >
      <VStack>
        {!waitingFromBlock && (
          <Stack alignSelf={'flex-end'} maxW={450} w={'100%'}>
            <RequestRandomForm
              errors={errors}
              register={registerRequestRandom}
            />
          </Stack>
        )}
        <HStack flexWrap={'wrap'} my={4} mt={8}>
          <Text>Consumer: </Text>
          <AddressBadge
            address={consumerAddress}
            fullAddress={true}
            withCopy={true}
          />
        </HStack>
        <Box>
          {isLoadingWords || waitingFromBlock ? (
            <Spinner />
          ) : (
            <Box
              p={4}
              border={'1px solid'}
              borderColor={'primary.100'}
              rounded={'md'}
            >
              {wordsAmount ? (
                <Text>
                  You have requested {wordsAmount} random words in last request!
                </Text>
              ) : (
                <Text>
                  You don&apos;t have any Request, please Request random number
                </Text>
              )}
            </Box>
          )}
        </Box>
      </VStack>
    </Section>
  )
}
